export default class User {
    cartId: string;
    userId: string;
    isLoggedIn: string;
    email: string;
    constructor(user: any = {}) {
        this.cartId = user.cartId;
        this.userId = user.userId;
        this.isLoggedIn = user.isLoggedIn;
        this.email = user.email;
    };
}
